import { render, staticRenderFns } from "./AddRuleDialog.vue?vue&type=template&id=7f50fd22&"
import script from "./AddRuleDialog.vue?vue&type=script&lang=js&"
export * from "./AddRuleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports